/* template */
<template><div class="sunflower-code"><div class="tip">{{ config.titleTip }}</div><div class="title">{{ config.content }}</div><div class="code-content"><mpx-image v-show="(codeImageUrl)" :src="(codeImageUrl)" mode="widthFix" :show-menu-by-longpress="(true)" class="code-image"/></div><mpx-view @tap="click" id="saveBtn" class="btn">{{ config.btnText }}<mpx-image src="https://ut-static.udache.com/webx/ut/6dMXZZlvPzAyILkloTHCe_saoguang_apng.apng" mode="widthFix" class="light" v-if="(hasGetCoupon)"/><div class="bonus-reward" v-if="(bonusRewardShow)">首次保存奖励{{initData.activity_info.save_poster_bonus}}福利金</div></mpx-view></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mfd045c34"}'>
@keyframes btn-breath {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.06);
  }
  100% {
    transform: scale(1);
  }
}
  .sunflower-code
    box-sizing: border-box
    width 750rpx
    height 590rpx
    background: url('https://ut-static.udache.com/webx/ut/i0iM3mAFyf9dMZTa3yP0I.png')
    background-repeat: no-repeat
    background-size: 100vw auto
    background-color: RGB(255, 102, 0)
    display: flex;
    align-items: center
    flex-direction: column
    .tip
      font-size: 22rpx;
      color: #CA7027;
      letter-spacing: 2rpx;
      text-align: center;
      font-weight: 700;
      margin-top: 18rpx
      font-family: AlibabaPuHuiTi-Bold;
    .title
      font-family: PingFangSC-Semibold;
      font-size: 32rpx;
      color: #F15711;
      letter-spacing: 2rpx;
      text-align: center;
      line-height: 50rpx;
      margin 32rpx 0 28rpx 0
      font-weight: 600;
    .code-content
      width: 240rpx
      height: 240rpx
      .code-image
        width: 240rpx
        height: 240rpx
    .btn
      font-family: AlibabaPuHuiTi-Medium;
      width: 530rpx;
      height: 90rpx;
      line-height: 90rpx;
      margin-top: 9rpx;
      background: #FF5000;
      background-image: linear-gradient(219deg, #FF6B00 0%, #FF5000 77%);
      border-radius: 66.5rpx;
      font-size: 42rpx;
      color: #FFFFFF;
      letter-spacing: 0;
      text-align: center;
      font-weight: 500;
      position relative
      .light
        position absolute
        left 0
        top 0
        width 530rpx
      .bonus-reward
        position absolute
        right -82rpx
        top -50rpx
        width 274rpx
        height 54rpx
        line-height 46rpx
        background-image url(https://ut-static.udache.com/webx/ut/f1xNB9ZxVjqt9lNHVaUIW.png)
        background-size cover
        text-align center
        font-family: PingFangSC-Medium;
        font-size: 24rpx;
        color: #FFF;
        font-weight: 500;
        animation btn-breath 1s infinite
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mfd045c34"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./sunflower-code.mpx.js?isComponent&outputPath=components%2Fsunflower-codefd045c34%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./sunflower-code.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fsunflower-codefd045c34%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mfd045c34"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/sunflower-codefd045c34/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
